"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageGGSC = void 0;
var react_1 = __importStar(require("react"));
var crumbs_1 = require("../crumbs");
var layout_1 = require("./shared/layout");
var mini_time_chart_1 = require("./shared/mini_time_chart");
var mini_k_chart_1 = require("./shared/mini_k_chart");
var title_bar_1 = require("./shared/title_bar");
var zixun_1 = require("./shared/zixun");
var title_quotetable_1 = require("./shared/title/title_quotetable");
var hk_rule_tip_1 = require("./shared/hk_rule_tip");
var hk_rule_1 = __importDefault(require("../../modules/hk_rule"));
var url_1 = require("../../modules/url");
var hkgototip_1 = require("../hk/hkgototip");
/**
 * 港股市场首页
 * @returns
 */
function PageGGSC() {
    var _this = this;
    var _a = (0, react_1.useState)(false), mounted = _a[0], setMounted = _a[1];
    var _b = (0, react_1.useState)(""), delaymessage = _b[0], setDelayMess = _b[1];
    var _c = (0, react_1.useState)("b:MK0101"), ahFS = _c[0], setAHFS = _c[1]; // A+H 比价
    var _d = (0, react_1.useState)("m:116+t:4"), cybFS = _d[0], setHKCYBFS = _d[1]; // 创业板
    var _e = (0, react_1.useState)("b:MK0103"), gqFS = _e[0], setGUOQIFS = _e[1]; // 国企
    var _f = (0, react_1.useState)("b:MK0102"), redFS = _f[0], setRedFS = _f[1]; //  红筹
    var _g = (0, react_1.useState)("b:MK0105"), blueFS = _g[0], setBlueFS = _g[1]; // 蓝筹
    var _h = (0, react_1.useState)(false), show_hk_goto_tips = _h[0], setShowHKGotoTips = _h[1];
    var _j = (0, react_1.useState)(''), hk_goto_link = _j[0], setHKGotoLink = _j[1];
    (0, react_1.useEffect)(function () {
        ;
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var delay_hk;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, hk_rule_1.default.isDelayCache()];
                    case 1:
                        delay_hk = _a.sent();
                        // delay_hk = {re:true,message:"延时市场"} // 测试字段
                        if (delay_hk === null || delay_hk === void 0 ? void 0 : delay_hk.re) {
                            setDelayMess(delay_hk.message);
                            setAHFS("b:DLMK0101");
                            setHKCYBFS("m:128+t:4");
                            setGUOQIFS("b:DLMK0103");
                            setRedFS("b:DLMK0102");
                            setBlueFS("b:DLMK0105");
                        }
                        setMounted(true);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    //港股合规,单页跳转提示
    (0, react_1.useEffect)(function () {
        var showhktip = (0, url_1.getQueryParams)('showhktip');
        var gotourl = (0, url_1.getQueryParams)('gotourl');
        if (showhktip == '1' && gotourl) {
            gotourl = decodeURIComponent(gotourl);
            //验证链接有效性
            var check = /^(http|https):\/\/[\w\.-]+\.eastmoney.com\//;
            if (!check.test(gotourl)) {
                return;
            }
            setShowHKGotoTips(true);
            setHKGotoLink(gotourl);
        }
    }, []);
    if (!mounted)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("div", { className: "pageggsc" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefreshLine, null),
        react_1.default.createElement(layout_1.Layout4, { mt: 5 },
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "100.HSI", height: 193, link: true, border: false }, "\u6052\u751F\u6307\u6570"),
                react_1.default.createElement("div", { style: { marginTop: 15 } },
                    react_1.default.createElement(mini_k_chart_1.MiniKChart, { quotecode: "100.HSI" }))),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "100.HSCEI", height: 193, link: true, border: false }, "\u56FD\u4F01\u6307\u6570"),
                react_1.default.createElement("div", { style: { marginTop: 15 } },
                    react_1.default.createElement(mini_k_chart_1.MiniKChart, { quotecode: "100.HSCEI" }))),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "124.HSCCI", height: 193, link: true, border: false }, "\u7EA2\u7B79\u6307\u6570"),
                react_1.default.createElement("div", { style: { marginTop: 15 } },
                    react_1.default.createElement(mini_k_chart_1.MiniKChart, { quotecode: "124.HSCCI" }))),
            react_1.default.createElement(layout_1.Layout4.Item, null,
                react_1.default.createElement(mini_time_chart_1.Title1MiniTimeChart, { quotecode: "125.SPHKG", height: 193, link: true, border: false }, "\u9999\u6E2F\u521B\u4E1A\u677F\u677F\u5757"),
                react_1.default.createElement("div", { style: { marginTop: 15 } },
                    react_1.default.createElement(mini_k_chart_1.MiniKChart, { quotecode: "125.SPHKG" })))),
        react_1.default.createElement(title_bar_1.TitleBar, { mt: 15 },
            react_1.default.createElement(title_bar_1.TitleBar.Title, null,
                react_1.default.createElement("a", { href: "//hk.eastmoney.com/news/cggdd.html" }, "\u6E2F\u80A1\u5BFC\u8BFB")),
            react_1.default.createElement(title_bar_1.TitleBar.Content, null,
                react_1.default.createElement(zixun_1.ColumnNewsScroll, { columns: "797" }))),
        react_1.default.createElement("div", { style: { marginTop: 8 } },
            react_1.default.createElement(GGSCChildTable, { tit: "A+H\u80A1\u6BD4\u4EF7", link: "gridlist.html#ah_comparison", fs: ahFS, orderdur: 1, bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8A+H\u80A1\u6BD4\u4EF7", table_key: 'AHTable2', delaymessage: delaymessage })),
        react_1.default.createElement(layout_1.Layout2, { mt: 7 },
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(GGSCChildTable, { tit: "\u56FD\u4F01\u80A1\u6DA8\u5E45\u699C", link: "gridlist.html#hk_stateowned", fs: gqFS, orderdur: 1, bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u56FD\u4F01\u80A1\u6DA8\u5E45\u699C", delaymessage: delaymessage })),
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(GGSCChildTable, { tit: "\u56FD\u4F01\u80A1\u8DCC\u5E45\u699C", link: "gridlist.html?sr=0#hk_stateowned", fs: gqFS, orderdur: 0, bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u56FD\u4F01\u80A1\u8DCC\u5E45\u699C", delaymessage: delaymessage }))),
        react_1.default.createElement(layout_1.Layout2, { mt: 7 },
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(GGSCChildTable, { tit: "\u7EA2\u7B79\u80A1\u6DA8\u5E45\u699C", link: "gridlist.html#hk_redchips", fs: redFS, orderdur: 1, bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u7EA2\u7B79\u80A1\u6DA8\u5E45\u699C", delaymessage: delaymessage })),
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(GGSCChildTable, { tit: "\u7EA2\u7B79\u80A1\u8DCC\u5E45\u699C", link: "gridlist.html?sr=0#hk_redchips", fs: redFS, orderdur: 0, bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u7EA2\u7B79\u80A1\u8DCC\u5E45\u699C", delaymessage: delaymessage }))),
        react_1.default.createElement(layout_1.Layout2, { mt: 7 },
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(GGSCChildTable, { tit: "\u84DD\u7B79\u80A1\u6DA8\u5E45\u699C", link: "gridlist.html#hk_bluechips", fs: blueFS, orderdur: 1, bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u84DD\u7B79\u80A1\u6DA8\u5E45\u699C", delaymessage: delaymessage })),
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(GGSCChildTable, { tit: "\u84DD\u7B79\u80A1\u8DCC\u5E45\u699C", link: "gridlist.html?sr=0#hk_bluechips", fs: blueFS, orderdur: 0, bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u84DD\u7B79\u80A1\u8DCC\u5E45\u699C", delaymessage: delaymessage }))),
        react_1.default.createElement(layout_1.Layout2, { mt: 7 },
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(GGSCChildTable, { tit: "\u521B\u4E1A\u677F\u6DA8\u5E45\u699C", link: "gridlist.html#hk_gem", fs: cybFS, orderdur: 1, bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u521B\u4E1A\u677F\u6DA8\u5E45\u699C", delaymessage: delaymessage })),
            react_1.default.createElement(layout_1.Layout2.Item, null,
                react_1.default.createElement(GGSCChildTable, { tit: "\u521B\u4E1A\u677F\u8DCC\u5E45\u699C", link: "gridlist.html?sr=0#hk_gem", fs: cybFS, orderdur: 0, bmtxt: "\u70B9\u51FB\u67E5\u770B\u5168\u90E8\u521B\u4E1A\u677F\u8DCC\u5E45\u699C", delaymessage: delaymessage }))),
        show_hk_goto_tips && react_1.default.createElement(hkgototip_1.HKGotoTip, { gotolink: hk_goto_link, onClose: function () { setShowHKGotoTips(false); } })));
}
exports.PageGGSC = PageGGSC;
/**
 * layout2小table
 * @param props
 * @returns
 */
function GGSCChildTable(props) {
    var table_key = props.table_key || 'HSGTTABLE';
    return (react_1.default.createElement(title_quotetable_1.Title1QuoteTable, { more: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { href: props.link }, "\u66F4\u591A>>")), bottom_more: react_1.default.createElement("a", { href: props.link },
            props.bmtxt,
            ">>"), table_key: table_key, fs: props.fs,
        count: 5,
        order: 'f3',
        orderdur: props.orderdur,
        tagclass: '' },
        react_1.default.createElement("a", { href: props.link, target: "_blank" }, props.tit),
        react_1.default.createElement(hk_rule_tip_1.HKDelayRoleTip, { tiptxt: props === null || props === void 0 ? void 0 : props.delaymessage })));
}
